import script from "./tipsDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./tipsDialog.vue?vue&type=script&lang=ts&setup=true"

import "./tipsDialog.vue?vue&type=style&index=0&id=346ed455&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-346ed455"]])

export default __exports__